angular.module('app.directives').directive('panelDeleteButton', ($translate, api, notify) => ({
    restrict: 'E',

    scope: {
        model: '=',
    },

    link(scope, element, attrs) {
        scope.permissions = '';

        scope.$watch('model', (model) => {
            if (model && model.id && !scope.permissions) {
                const modelPlural = `${model._model.toLowerCase()}s`;

                scope.permissions = {};
                scope.permissions[`${modelPlural}__manage_all`] = 0;
                scope.permissions[`${modelPlural}__manage`] = _.filter([model.author_id, model.owner_id]);
            }
        });

        scope.toggleDelete = () => {
            const question = scope.model._deleted ? 'sure_to_restore' : 'sure_to_remove';
            const saving = scope.model._deleted ? 'restoring' : 'removing';
            const saved = scope.model._deleted ? 'restored' : 'removed';
            const func = scope.model._deleted ? 'restore' : 'remove';

            UIkit.modal.confirm(
                $translate.instant(question),
                () => {
                    const modelPlural = `${scope.model._model.toLowerCase()}s`;
                    const apiModel = api(modelPlural);
                    const info = notify.info($translate.instant(saving));
                    notify.global(1);

                    apiModel[func](scope.model.id).then((response) => {
                        scope.model = response;
                        apiModel.clearCache();

                        info.close();
                        notify.success($translate.instant(saved));
                        notify.global(0);
                    });
                },
                {
                    labels: {
                        Ok: $translate.instant('yes'),
                        Cancel: $translate.instant('cancel'),
                    },
                }
            );
        };
    },

    templateUrl: '/directives/buttons/panel_delete_button.html',
}));
